import React, { useEffect, useState, useRef } from "react";
import "./ExperienceSection.css";
import images from "../../constants/images";

/* ===== COUNTER COMPONENT ===== */
const Counter = ({ end, start }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!start) return;

    let current = 0;
    const step = end / 80;

    const interval = setInterval(() => {
      current += step;
      if (current >= end) {
        clearInterval(interval);
        setCount(end);
      } else {
        setCount(Math.floor(current));
      }
    }, 20);

    return () => clearInterval(interval);
  }, [start, end]);

  return <>{count}</>;
};

const ExperienceSection = () => {
  const sectionRef = useRef(null);
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true);
          observer.disconnect();
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="experience" ref={sectionRef}>
      {/* LEFT IMAGE */}
      <div className="experience-image">
        <img src={images.experience_img1} alt="Interior Design" />
      </div>

      {/* RIGHT CONTENT */}
      <div className="experience-content">
        {/* ===== STATS ===== */}
        <div className="experience-stats">
          {/* STAT 1 */}
          <div className="stat">
            <h3>
              <Counter end={200} start={startCount} />
              <span>+</span>
            </h3>
            <span className="sub-heading">Completed Projects</span>
          </div>

          {/* STAT 2 */}
          <div className="stat">
            <h3>
              <Counter end={5} start={startCount} />
              <span>+</span>
            </h3>
            <span className="sub-heading">Years of Experience</span>
          </div>

          {/* STAT 3 (NEW) */}
          <div className="stat">
            <h3>
              <Counter end={100} start={startCount} />
              <span>+</span>
            </h3>
            <span className="sub-heading">Satisfied Clients</span>
          </div>
        </div>

        <h2>Experience the Difference</h2>

        <p>
          We craft spaces that feel uniquely yours—from initial concept to final detail through architecture, interior design, 3D visualization, and precise BIM execution. Let’s bring your vision to life.
        </p>

        <div className="contact-box">
          <div className="icon">📞</div>
          <div>
            <span>Talk to our expert</span>
            <strong>+33 605 905 713</strong>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
